import React, { useEffect, useState } from "react";
import { Redirect, Route } from "react-router-dom";
import { useUser } from "../../UserContext";
import SkeletonLoading from "./SkeletonLoading";
import { isOperationsUser } from "../../firebase/OperationsConsoleService";

const ConsoleRoute = ({ component: Component, ...rest }) => {
  const { user } = useUser();
  const [isAuthReady, setIsAuthReady] = useState(false);
  const [firebaseUser, setFirebaseUser] = useState(null);

  useEffect(() => {
    let unsubscribe = null;
    let cancelled = false;
    const init = async () => {
      const [{ onAuthStateChanged }, { auth }] = await Promise.all([
        import("firebase/auth"),
        import("../../firebase/firebase"),
      ]);
      if (cancelled) return;
      unsubscribe = onAuthStateChanged(auth, (fbUser) => {
        setFirebaseUser(fbUser || null);
        setIsAuthReady(true);
      });
    };
    init();
    return () => {
      cancelled = true;
      if (unsubscribe) unsubscribe();
    };
  }, []);

  return (
    <Route
      {...rest}
      render={(props) => {
        if (!isAuthReady || (firebaseUser && !user)) return <SkeletonLoading />;
        if (!firebaseUser || !user) return <Redirect to="/login" />;
        if (!isOperationsUser(user)) return <Redirect to="/unauthorized" />;
        return <Component {...props} />;
      }}
    />
  );
};

export default ConsoleRoute;
